"use strict";

exports.__esModule = true;
exports.AppContainer = AppContainer;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AppSidebar = require("../AppSidebar");
var _AppRoutes = require("../AppRoutes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "AppContainer__Container",
  componentId: "sc-1fp6lhy-0"
})(["display:flex;height:100vh;"]);
function AppContainer(props) {
  return /*#__PURE__*/_react["default"].createElement(Container, {
    "data-testid": "AppContainer"
  }, /*#__PURE__*/_react["default"].createElement(_AppSidebar.AppSidebar, {
    isSidebarExpanded: props.isSidebarExpanded,
    setIsSidebarExpanded: props.setIsSidebarExpanded
  }), /*#__PURE__*/_react["default"].createElement(_AppRoutes.AppRoutes, null), props.children);
}